// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjcycHgiIGhlaWdodD0iNzJweCIgdmlld0JveD0iMCAwIDcyIDcyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0My4yICgzOTA2OSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+dmlkZW8gaWNvbiBjb3B5IDQ8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iSG9tZXBhZ2UiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJIb21lcGFnZS1fZGVza3RvcCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ3MC4wMDAwMDAsIC0zMDEyLjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iZnd0diIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIwLjAwMDAwMCwgMjc4OC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJiaWctdmlkZW8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCA1MC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0idmlkZW8tMnB4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNTEuMDAwMDAwLCAxNzUuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJ2aWRlby1jb3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNS4wMDAwMDAsIDM1LjAwMDAwMCkgcm90YXRlKC0zNjAuMDAwMDAwKSB0cmFuc2xhdGUoLTM1LjAwMDAwMCwgLTM1LjAwMDAwMCkgIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwtMiIgc3Ryb2tlPSIjRkZGRkZGIiBzdHJva2Utd2lkdGg9IjIiIGZpbGwtb3BhY2l0eT0iMC4xNSIgZmlsbD0iIzAwMDAwMCIgY3g9IjM1IiBjeT0iMzUiIHI9IjM1Ij48L2NpcmNsZT4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJUcmlhbmdsZSIgZmlsbD0iI0ZGRkZGRiIgcG9pbnRzPSIyNi45ODI4NTY5IDQ5Ljk1Mzc1MiAyNi45ODI4NTY5IDE5LjM0MjEwNTMgNDguNTQzNDU4OSAzMy45OTY5NDI5Ij48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.player-wrapper {
  --eve-accent: var(--player-primary-color, #e00);
}
.player-wrapper .theo-primary-color,
.player-wrapper .vjs-selected {
  color: var(--player-primary-color);
}
.player-wrapper .video-js.hide-controls .vjs-control-bar {
  display: none !important;
}
.player-wrapper .video-js.hide-controls .vjs-tech {
  pointer-events: none;
}
.player-wrapper .video-js.hide-controls .theoplayer-texttracks {
  display: none !important;
}
.player-wrapper .video-js.hide-casts .theo-cast-button {
  display: none !important;
}
.player-wrapper .player-container.vjsp-widescreen {
  aspect-ratio: unset;
  padding: 0;
  height: calc(100vh - var(--navbar-height-player-page-mobile));
  height: calc(100svh - var(--navbar-height-player-page-mobile));
}
@media (min-width: 430px) {
  .player-wrapper .player-container.vjsp-widescreen {
    height: calc(100vh - var(--navbar-height-player-page-mobile));
  }
}
@media (min-width: 1200px) {
  .player-wrapper .player-container.vjsp-widescreen {
    height: calc(100vh - var(--navbar-height-player-page-desktop));
  }
}
.player-wrapper .player-container.vjsp-widescreen .video-js {
  width: 100%;
  height: 100% !important;
  padding-top: 0 !important;
}
.player-wrapper .vjs-text-track-display {
  transition: bottom 0.2s;
}
.player-wrapper .theo-primary-background {
  color: var(--player-primary-bg-color) !important;
  background-color: var(--player-primary-color) !important;
}
.player-wrapper {
  /* Increase button size when hovering */
}
.player-wrapper .theoplayer-skin .vjs-big-play-button:hover {
  background: none;
  -webkit-transition-duration: 0.2s;
  -moz-transition-duration: 0.2s;
  transition-duration: 0.2s;
  transform: translate(-50%, -50%) scale(1.2);
  transition: transform 0.2s;
}
.player-wrapper {
  /* Set other image */
}
.player-wrapper .theoplayer-skin .vjs-big-play-button:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 0 0;
  background-size: 100%;
  display: block;
}
.player-wrapper {
  /* Remove default THEOplayer image */
}
.player-wrapper .theo-big-play-button-svg-container svg {
  display: none;
}
.player-wrapper {
  /* Remove default spotlight around button on focus */
}
.player-wrapper .theoplayer-skin:hover .vjs-big-play-button:after,
.player-wrapper .theoplayer-skin .vjs-big-play-button:focus:after {
  opacity: 0;
}
.player-wrapper .player-cover-layout {
  background-color: #333;
  object-fit: contain;
  height: 100%;
  width: 100%;
  max-width: 100%;
  position: absolute;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.player-wrapper .player-cover-layout .ant-spin-dot-item {
  background-color: white;
}
.player-wrapper .hide-speed .theo-settings-control-menu .theo-menu:not(.theo-submenu) li:nth-child(2) {
  display: none !important;
}
.player-wrapper .vjs-control-bar {
  z-index: 1;
}
.player-wrapper .theo-menu-animatable {
  z-index: 1;
}
.player-wrapper--disable-fullscreen .vjs-fullscreen-control {
  display: none;
}

.force-live .video-js .vjs-tech {
  pointer-events: none;
}
.force-live .video-js .vjs-play-control {
  display: none;
}
.force-live .video-js .vjs-time-control {
  display: none;
}
.force-live .video-js .vjs-seek-to-live-control {
  display: flex !important;
}
.force-live .video-js .vjs-seek-to-live-control .vjs-icon-placeholder {
  color: #e00 !important;
}
.force-live .vjs-progress-control {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Player/Player.scss"],"names":[],"mappings":"AAEA;EAQI,+CAAA;AARJ;AAUI;;EAEI,kCAAA;AARR;AAWI;EACI,wBAAA;AATR;AAYI;EACI,oBAAA;AAVR;AAaI;EACI,wBAAA;AAXR;AAcI;EACI,wBAAA;AAZR;AAoBI;EACI,mBAAA;EACA,UAAA;EACA,6DAAA;EACA,8DAAA;AAlBR;AAoBQ;EANJ;IAOQ,6DAAA;EAjBV;AACF;AAmBQ;EAVJ;IAWQ,8DAAA;EAhBV;AACF;AAkBQ;EACI,WAAA;EACA,uBAAA;EAGA,yBAAA;AAlBZ;AAsBI;EACI,uBAAA;AApBR;AAuBI;EACI,gDAAA;EACA,wDAAA;AArBR;AA5CA;EAuFI,uCAAA;AAxCJ;AAyCI;EACI,gBAAA;EACA,iCAAA;EACA,8BAAA;EACA,yBAAA;EACA,2CAAA;EACA,0BAAA;AAvCR;AAvDA;EAiGI,oBAAA;AAvCJ;AAwCI;EACI,WAAA;EACA,iEAAA;EAEA,qBAAA;EACA,cAAA;AAvCR;AAhEA;EA0GI,oCAAA;AAvCJ;AAwCI;EACI,aAAA;AAtCR;AAtEA;EA+GI,oDAAA;AAtCJ;AAuCI;;EAEI,UAAA;AArCR;AAwCI;EACI,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAtCR;AAwCQ;EACI,uBAAA;AAtCZ;AA6CgB;EAEI,wBAAA;AA5CpB;AAkDI;EACI,UAAA;AAhDR;AAmDI;EACI,UAAA;AAjDR;AAqDQ;EACI,aAAA;AAnDZ;;AA0DQ;EACI,oBAAA;AAvDZ;AA0DQ;EACI,aAAA;AAxDZ;AA2DQ;EACI,aAAA;AAzDZ;AAmEQ;EACI,wBAAA;AAjEZ;AAuEQ;EACI,sBAAA;AArEZ;AAyEI;EACI,wBAAA;AAvER","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
